<div *ngIf="!loading; else loadingTemplate" class="shared-table">
  <ng-container *ngIf="isEmpty; else tableElements">
    <fz-empty-list
      [header]="configuration.emptyState?.title || 'No Data'"
      [isLoggedIn]="
        currentUser && currentUser.user && currentUser.user.email !== null
      "
      [loggedInMessage]="
        configuration.emptyState?.loggedInMessage ||
        'There is no data for this table.'
      "
      [src]="configuration.emptyState?.src"
      [buttonText]="configuration.emptyState?.buttonText || null"
      [loggedOutMessage]="
        configuration.emptyState?.loggedOutMessage ||
        'Please login to see all the details'
      "
      (buttonEvent)="onEmptyButtonPressed()"
      (loginEvent)="onLoginButtonPressed()"
    ></fz-empty-list>
  </ng-container>
</div>
<ng-template #loadingTemplate>
  <div class="" style="width: 100%">
    <fz-loading-component [total]="1" [type]="'table'"></fz-loading-component>
  </div>
</ng-template>
<ng-template #tableElements>
  <mat-card
    appearance="outlined"
    class="mobile-table bottom-spacer"
    *ngFor="let element of _data; let i = index"
    style="padding: 0"
    [class.highlighted]="element.highlighted"
  >
    <mat-card-content>
      <div
        class="small-padding spaced mobile-row {{ column.id }}"
        [ngClass]="{
          'actions-column': column.title === 'Actions',
          'actions-column-empty':
            column.title === 'Actions' &&
            column.actionsToShow(element).length === 0
        }"
        *ngFor="let column of displayedColumns"
      >
        <div *ngIf="column.title !== 'Actions'">
          <span
            class="mat-subtitle-2 column-title"
            #headerTooltip="matTooltip"
            matTooltip="{{
              configuration &&
                configuration.headersTooltip &&
                configuration.headersTooltip[column.id]
            }}"
          >
            {{ column.title }}
            <mat-icon
              *ngIf="
                configuration &&
                configuration.headersTooltip &&
                configuration.headersTooltip[column.id] !== undefined
              "
              class="icon-grey tooltip-icon"
              >info</mat-icon
            >
          </span>
        </div>
        <div>
          <div
            class="table-row"
            #bodyTooltip="matTooltip"
            matTooltip="{{ column.tooltip(element) }}"
            data-ga-value="{{ configuration && configuration.tableName }}-table"
            (click)="
              onView({ data: element, cellName: column.id });
              $event.stopPropagation()
            "
          >
            <img
              *ngIf="column.type(element) === ColumnTypes.IMG"
              class="game-image"
              [src]="column.mapping(element)"
            />
            <span
              *ngIf="column.type(element) === ColumnTypes.EVENT"
              class="number"
            >
              {{ column.mapping(element) }}
            </span>
            <span
              *ngIf="column.type(element) === ColumnTypes.DATE"
              class="date-cell"
              ><span class="">
                {{
                  column.mapping(element) | fzDateFormat: 'E, MMM d, y' | async
                }}
              </span>
              <span class="mat-subtitle-2">
                {{ column.mapping(element) | fzDateFormat: 'h:mm:ss' | async }}
              </span>
            </span>
            <a *ngIf="column.type(element) === ColumnTypes.LINK" class="link">
              column.mapping(element)
            </a>
            <div *ngIf="column.type(element) === ColumnTypes.AVATAR">
              {{ column.mapping(element).name }}
            </div>
            <div *ngIf="column.type(element) === ColumnTypes.RANGE">
              <fz-currency
                *ngIf="column.type(element) === ColumnTypes.RANGE"
                [value]="column.mapping(element).start"
              ></fz-currency>
              -
              <fz-currency
                *ngIf="column.type(element) === ColumnTypes.RANGE"
                [value]="column.mapping(element).end"
              ></fz-currency>
            </div>
            <div
              *ngIf="column.type(element) === ColumnTypes.CUSTOM"
              [innerHTML]="column.customElement(element) | safe: 'html'"
            ></div>
            <span
              *ngIf="
                column.showCustomPopover && column.showCustomPopover(element)
              "
              class="popover-icon"
              (mouseover)="element.mobPopoverOpen = true"
              (click)="
                element.mobPopoverOpen = !element.mobPopoverOpen;
                $event.stopPropagation();
                $event.preventDefault()
              "
              cdkOverlayOrigin
              #trigger="cdkOverlayOrigin"
            >
              <mat-icon class="tooltip-icon">info</mat-icon>
              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayBackdropClass]="element.id"
                [cdkConnectedOverlayOpen]="element.mobPopoverOpen"
              >
                <div
                  class="overlay-container {{ element.id }}"
                  (mouseleave)="element.mobPopoverOpen = false"
                >
                  <div [class.big]="element.isLEP">
                    <div
                      class="overlay-pane custom-table mat-caption"
                      [class.big]="element.isLEP"
                    >
                      <div class="content">
                        <button
                          mat-icon-button
                          class="popover-close"
                          (click)="element.mobPopoverOpen = false"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                        <ng-container>
                          <div
                            [innerHTML]="
                              column.customPopover(element) | safe: 'html'
                            "
                          ></div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </span>
            <fz-currency
              *ngIf="column.type(element) === ColumnTypes.CURRENCY"
              [value]="column.mapping(element)"
            ></fz-currency>
            <span *ngIf="column.type(element) === ColumnTypes.DEFAULT">
              {{ column.mapping(element) }}
            </span>
            <div *ngIf="column.type(element) === ColumnTypes.CHIP">
              <span>{{ column.mapping(element) }}</span>
              <img class="chip-img" [src]="column.srcImg" />
            </div>

            <mat-icon
              *ngIf="
                column.tooltip(element) &&
                column.type(element) !== ColumnTypes.EVENT &&
                column.type(element) !== ColumnTypes.IMG &&
                column.type(element) !== ColumnTypes.CHIP
              "
              class="icon-grey tooltip-icon"
              >info</mat-icon
            >
            <div
              *ngIf="column.type(element) === ColumnTypes.ACTIONS"
              class="table-actions-column"
            >
              <fz-play-button
                *ngIf="
                  column.actionsToShow(element) &&
                  column.actionsToShow(element).includes(ActionTypes.PLAY)
                "
                [tournament]="column.tournament(element)"
                [eventSchedule]="column.eventSchedule(element)"
                [timesPlayedInfo]="eventsPlayedInfo"
                [currentUser]="currentUser"
                [isLoggedIn]="isLoggedIn"
                [passesLoaded]="passesLoaded"
                [timesPlayedInfo]=""
                [location]="location"
                [passUuid]="column.passUuid(element)"
                [locationLoaded]="locationLoaded"
                [playButtonText]="column.playButtonText(element)"
                [basic]="column.playButtonIsBasic || false"
                (clickPressed)="onPlayPressed(element)"
                data-ga-value="{{
                  configuration && configuration.tableName
                }}-table-play"
              ></fz-play-button>
              <button
                *ngIf="
                  column.actionsToShow(element) &&
                  column.actionsToShow(element).includes(ActionTypes.SHARE)
                "
                (click)="onSharePressed(element); $event.stopPropagation()"
                mat-icon-button
                matTooltip="{{ element.retired ? 'Retired' : 'Share' }}"
                matTooltipClass="info-tooltip"
                data-ga-value="{{
                  configuration && configuration.tableName
                }}table-share"
              >
                <mat-icon class="icon-grey">share</mat-icon>
              </button>
              <button
                *ngIf="
                  column.actionsToShow(element) &&
                  column.actionsToShow(element).includes(ActionTypes.DETAILS)
                "
                (click)="onDetailsPressed(element); $event.stopPropagation()"
                mat-icon-button
                matTooltip="Details"
                matTooltipClass="info-tooltip"
                data-ga-value="{{
                  configuration && configuration.tableName
                }}-table-details"
                aria-label="Button that displays a tooltip when focused or hovered over"
              >
                <mat-icon class="icon-grey">visibility</mat-icon>
              </button>
              <button
                *ngIf="
                  column.actionsToShow(element) &&
                  column.actionsToShow(element).includes(ActionTypes.CUSTOM) &&
                  column.customElement(element)
                "
                (click)="onCustomPressed(element); $event.stopPropagation()"
                mat-flat-button
                color="primary"
                data-ga-value="{{
                  configuration && configuration.tableName
                }}-table-{{ column.customElement(element) }}"
              >
                {{ column.customElement(element) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <div class="table-wrapper">
    <table
      mat-table
      class="desktop-table full-width-table"
      aria-label="Elements"
      matSort
      [fixedLayout]="configuration.fixedLayout === true"
      [dataSource]="matDataSource"
    >
      <!-- Columns for table -->
      <ng-container
        *ngFor="let column of displayedColumns"
        matColumnDef="{{ column.id }}"
      >
        <th
          class="table-header"
          [ngClass]="{
            'text-center':
              column.align && column.align === alignPositions.CENTER,
            'text-right': column.align && column.align === alignPositions.RIGHT,
            'text-left': column.align && column.align === alignPositions.LEFT
          }"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
        >
          <span
            class="mat-subtitle-2 column-title"
            #headerTooltip="matTooltip"
            matTooltip="{{
              configuration &&
                configuration.headersTooltip &&
                configuration.headersTooltip[column.id]
            }}"
          >
            {{ column.title }}
            <mat-icon
              *ngIf="
                configuration &&
                configuration.headersTooltip &&
                configuration.headersTooltip[column.id] !== undefined
              "
              class="icon-grey tooltip-icon"
              >info</mat-icon
            >
          </span>
        </th>
        <td
          class="table-row"
          [ngClass]="{ highlighted: highlighted === i }"
          [ngClass]="{
            'text-center':
              column.align && column.align === alignPositions.CENTER,
            'text-right': column.align && column.align === alignPositions.RIGHT,
            'text-left': column.align && column.align === alignPositions.LEFT
          }"
          mat-cell
          *matCellDef="let element; let i = index"
          #bodyTooltip="matTooltip"
          matTooltip="{{ column.tooltip(element) }}"
          data-ga-value="{{ configuration && configuration.tableName }}-table"
          (click)="
            onView({ data: element, cellName: column.id });
            $event.stopPropagation()
          "
        >
          <div>
            <img
              *ngIf="column.type(element) === ColumnTypes.IMG"
              class="game-image"
              [src]="column.mapping(element)"
            />
            <span
              *ngIf="column.type(element) === ColumnTypes.EVENT"
              class="number"
            >
              {{ column.mapping(element) }}
            </span>
            <span
              *ngIf="column.type(element) === ColumnTypes.DATE"
              class="date-ctn"
              ><span class="">
                {{
                  column.mapping(element) | fzDateFormat: 'E, MMM d, y' | async
                }}
              </span>
              <span class="mat-subtitle-2">
                {{ column.mapping(element) | fzDateFormat: 'h:mm:ss' | async }}
              </span>
            </span>
            <a *ngIf="column.type(element) === ColumnTypes.LINK" class="link">
              column.mapping(element)
            </a>
            <div
              *ngIf="column.type(element) === ColumnTypes.CUSTOM"
              [innerHTML]="column.customElement(element) | safe: 'html'"
            ></div>
            <img
              *ngIf="column.type(element) === ColumnTypes.AVATAR"
              class="avatar-image"
              [src]="column.mapping(element).imageUrl"
            />
            <div *ngIf="column.type(element) === ColumnTypes.RANGE">
              <fz-currency
                *ngIf="column.type(element) === ColumnTypes.RANGE"
                [value]="column.mapping(element).start"
              ></fz-currency>
              -
              <fz-currency
                *ngIf="column.type(element) === ColumnTypes.RANGE"
                [value]="column.mapping(element).end"
              ></fz-currency>
            </div>
            <fz-currency
              *ngIf="column.type(element) === ColumnTypes.CURRENCY"
              class="currency-column"
              [value]="column.mapping(element)"
            ></fz-currency>
            <span *ngIf="column.type(element) === ColumnTypes.DEFAULT">
              {{ column.mapping(element) }}
            </span>
            <div *ngIf="column.type(element) === ColumnTypes.CHIP">
              <span>{{ column.mapping(element) }}</span>
              <img class="chip-img" [src]="column.srcImg" />
            </div>
            <mat-icon
              *ngIf="
                column.tooltip(element) &&
                column.type(element) !== ColumnTypes.EVENT &&
                column.type(element) !== ColumnTypes.IMG &&
                column.type(element) !== ColumnTypes.CHIP
              "
              class="icon-grey tooltip-icon"
              >info</mat-icon
            >
            <span
              *ngIf="
                column.showCustomPopover && column.showCustomPopover(element)
              "
              class="popover-icon"
              (mouseover)="element.deskPopoverOpen = true"
              (click)="
                element.deskPopoverOpen = !element.deskPopoverOpen;
                $event.stopPropagation();
                $event.preventDefault()
              "
              cdkOverlayOrigin
              #trigger="cdkOverlayOrigin"
            >
              <mat-icon class="tooltip-icon">info</mat-icon>
              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayBackdropClass]="element.id"
                [cdkConnectedOverlayOpen]="element.deskPopoverOpen"
              >
                <div
                  class="overlay-container"
                  (mouseleave)="element.deskPopoverOpen = false"
                >
                  <div
                    class="overlay-pane custom-table mat-caption"
                    [class.big]="element.isLEP"
                  >
                    <div class="content">
                      <button
                        mat-icon-button
                        class="popover-close"
                        (click)="element.deskPopoverOpen = false"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                      <ng-container>
                        <div
                          [innerHTML]="
                            column.customPopover(element) | safe: 'html'
                          "
                        ></div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-template>
            </span>
            <div
              *ngIf="column.type(element) === ColumnTypes.ACTIONS"
              class="table-actions-column"
            >
              <fz-play-button
                *ngIf="
                  column.actionsToShow(element) &&
                  column.actionsToShow(element).includes(ActionTypes.PLAY)
                "
                [tournament]="column.tournament(element)"
                [eventSchedule]="column.eventSchedule(element)"
                [timesPlayedInfo]="eventsPlayedInfo"
                [currentUser]="currentUser"
                [isLoggedIn]="isLoggedIn"
                [passesLoaded]="passesLoaded"
                [location]="location"
                [passUuid]="column.passUuid(element)"
                [locationLoaded]="locationLoaded"
                [playButtonText]="column.playButtonText(element)"
                [basic]="column.playButtonIsBasic || false"
                (clickPressed)="onPlayPressed(element)"
                data-ga-value="{{
                  configuration && configuration.tableName
                }}-table-play"
              ></fz-play-button>
              <button
                *ngIf="
                  column.actionsToShow(element) &&
                  column.actionsToShow(element).includes(ActionTypes.SHARE)
                "
                (click)="onSharePressed(element); $event.stopPropagation()"
                mat-icon-button
                matTooltip="{{ element.retired ? 'Retired' : 'Share' }}"
                matTooltipClass="info-tooltip"
                data-ga-value="{{
                  configuration && configuration.tableName
                }}-table-share"
              >
                <mat-icon class="font-color--tertiary">share</mat-icon>
              </button>
              <button
                *ngIf="
                  column.actionsToShow(element) &&
                  column.actionsToShow(element).includes(ActionTypes.DETAILS)
                "
                (click)="onDetailsPressed(element); $event.stopPropagation()"
                mat-icon-button
                matTooltip="Details"
                matTooltipClass="info-tooltip"
                aria-label="Button that displays a tooltip when focused or hovered over"
                data-ga-value="{{
                  configuration && configuration.tableName
                }}-table-details"
              >
                <mat-icon class="font-color--tertiary">visibility</mat-icon>
              </button>
              <button
                *ngIf="
                  column.actionsToShow(element) &&
                  column.actionsToShow(element).includes(ActionTypes.CUSTOM) &&
                  column.customElement(element)
                "
                (click)="onCustomPressed(element); $event.stopPropagation()"
                mat-flat-button
                class="mat-button-legacy"
                color="primary"
                data-ga-value="{{
                  configuration && configuration.tableName
                }}-table-{{ column.customElement(element) }}"
              >
                {{ column.customElement(element) }}
              </button>
              <div
                *ngIf="
                  column.actionsToShow(element) &&
                  column.actionsToShow(element).includes(ActionTypes.HTML)
                "
              >
                {{ column.customElement(element) }}
              </div>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="display"></tr>
      <tr
        mat-row
        [class.highlighted]="row.highlighted"
        *matRowDef="let row; columns: display"
      ></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="6">No data</td>
      </tr>
    </table>
    <mat-paginator
      *ngIf="
        configuration &&
        configuration.pagination &&
        configuration.pagination.showPagination &&
        (configuration.pagination.paginationTotal || 0) > 5
      "
      class="paginator-mobile"
      [length]="
        configuration &&
        configuration.pagination &&
        configuration.pagination.paginationTotal
      "
      [showFirstLastButtons]="true"
      (page)="onPageChange($event)"
      [pageSizeOptions]="
        configuration &&
        configuration.pagination &&
        configuration.pagination.paginationSizeOptions
      "
      [pageIndex]="page.pageIndex"
      [pageSize]="page.pageSize"
      aria-label="Select page"
      data-ga-value="{{
        configuration && configuration.tableName
      }}-table-pagination"
    >
    </mat-paginator>
  </div>
</ng-template>
